import React from 'react';
import { TextLink } from 'ui-builder';
import { TextLinkFieldProps } from './types';
import { useFieldHelper } from 'ui-builder';

export function TextLinkField(props: TextLinkFieldProps) {
  const fieldHelper = useFieldHelper(props);

  const link = fieldHelper.getValue() as string;

  return (
    <TextLink
      href={link}
      target="_blank"
      className={fieldHelper.getBaseLayoutProps().className}
    >
      {link}
    </TextLink>
  );
}
